export default __webpack_public_path__ + "static/homepage-lemon-cake-4cd0b3601b3effdba2d1ebdb70dec586.jpg";